import { useState } from 'react';
import { otherTheme, setTheme, startTheme, type ThemeMode } from '../lib/theme';

/**
 * Day or night, in one control.
 *
 * The mode is already settled before this renders - the page sets it before
 * its first paint - so this only reads it back, and writing it is the whole
 * of what the button does.
 */
export function ModeToggle() {
  const [mode, setMode] = useState<ThemeMode>(() => startTheme());
  const next = otherTheme(mode);
  const label = next === 'night' ? 'Switch to night' : 'Switch to day';
  return (
    <button type="button" className="mode" aria-label={label} title={label}
      onClick={() => { setTheme(next); setMode(next); }}>
      <span aria-hidden="true">{mode === 'night' ? '☾' : '☀'}</span>
    </button>
  );
}
